<template>
  <div>
    <div>
      <div class="row">
        <div class="col-md-12" id="vacataires">
          <table v-if="derogationsLoaded" class="table">
            <thead style="background-color: #003667; color: white">
              <tr class="text-center">
                <td>Code Agresso</td>
                <td>Vacataire</td>
                <td>Etablissement</td>
                <td>Nombre d'heures</td>
                <td>Année universitaire</td>
                <td>Commentaire</td>
                <td>Status</td>
                <td>Date demande</td>
                <td>Date validation</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <tr
                class="text-center"
                v-for="derogation in derogations"
                :key="`vac_${derogation.id}`"
              >
                <td>#{{ derogation.vacataire.agresso }}</td>
                <td>
                  {{ derogation.vacataire.nom }}
                  {{ derogation.vacataire.prenom }}
                </td>
                <td>{{ derogation.etablissement.code }}</td>
                <td>{{ derogation.nb_heures }} H</td>
                <td>{{ derogation.annee_universitaire }}</td>
                <td>{{ derogation.commentaire }}</td>
                <td>
                  <span
                    v-show="derogation.status == 'en cours'"
                    class="label label-xl label-info label-inline ml-3"
                  >
                    {{ derogation.status }}
                  </span>
                  <span
                    v-show="derogation.status == 'valide'"
                    class="label label-xl label-success label-inline ml-3"
                  >
                    {{ derogation.status }}
                  </span>
                  <span
                    v-show="derogation.status == 'refusee'"
                    class="label label-xl label-danger label-inline ml-3"
                  >
                    {{ derogation.status }}
                  </span>
                </td>
                <td>{{ derogation.date_demande }}</td>
                <td>{{ derogation.date_validation }}</td>
                <td v-show="admin.role.nom == 'DE'">
                  <button
                    v-if="derogation.status == 'en cours'"
                    @click="delete_derogation_modal(derogation)"
                    class="btn btn-outline-danger btn-sm btn-icon"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
                <td v-show="admin.role.nom == 'DOYEN'">
                  <button
                    v-if="derogation.status == 'en cours'"
                    @click="refuse_derogation_modal(derogation)"
                    class="btn btn-outline-danger btn-sm btn-icon mr-2"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                  <button
                    v-if="derogation.status == 'en cours'"
                    @click="valide_derogation_modal(derogation)"
                    class="btn btn-outline-success btn-sm btn-icon"
                  >
                    <i class="fa fa-check"></i>
                  </button>
                </td>
              </tr>
              <tr v-show="!derogations.length">
                <td colspan="9" class="text-center">
                  Aucune Derogation trouvé.
                </td>
              </tr>
            </tbody>
            <div>
              <jw-pagination
                :items="allDerogations"
                @changePage="onChangePageDerogation"
              ></jw-pagination>
            </div>
          </table>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div id="vacataires" class="col-12 col-md-6">
            <h4 class="text-center">vacataires</h4>
            <div
              class="col-md-12 text-center mb-3 d-flex justify-content-around"
            >
              <div class="search-zone">
                <div class="input-icon input-icon-right">
                  <input
                    v-model="keyword"
                    type="text"
                    placeholder="Recherche ..."
                    class="w-100 form-control basic_datatable_search_query"
                  />
                  <span><i class="flaticon2-search-1 icon-md"></i></span>
                </div>
              </div>
            </div>

            <div class="table-container">
              <table v-if="vacatairesLoaded" class="table">
                <tbody>
                  <tr
                    v-for="vacataire in vacataires"
                    :key="`vac_${vacataire.id}`"
                  >
                    <td width="50%">
                      #{{ vacataire.agresso }} {{ vacataire.nom }}
                      {{ vacataire.prenom }}
                    </td>
                    <td class="td-actions text-right">
                      <button
                        @click="show(vacataire)"
                        class="btn btn-outline-info btn-sm btn-icon edit"
                      >
                        <i class="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                  <tr class="text-center" v-show="!allVacataires.length">
                    <td>Aucun vacataire trouvé.</td>
                  </tr>
                </tbody>
              </table>
              <div>
                <jw-pagination
                  :items="allVacataires"
                  @changePage="onChangePage"
                ></jw-pagination>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <h4 class="text-center">vacataire</h4>
            <!--begin::Group-->
            <div class="form-group row">
              <label class="col-form-label col-3 text-lg-right text-left"
                >Nom</label
              >
              <div class="col-9">
                <input
                  class="form-control form-control-lg form-control-solid"
                  type="text"
                  v-model="vacataire.nom"
                  disabled
                />
              </div>
            </div>
            <!--end::Group-->
            <!--begin::Group-->
            <div class="form-group row">
              <label class="col-form-label col-3 text-lg-right text-left"
                >Prénom</label
              >
              <div class="col-9">
                <input
                  class="form-control form-control-lg form-control-solid"
                  type="text"
                  v-model="vacataire.prenom"
                  disabled
                />
              </div>
            </div>
            <!--end::Group-->
            <!--begin::Group-->
            <div class="form-group row">
              <label class="col-form-label col-3 text-lg-right text-left"
                >Ministère de Tutelle</label
              >
              <div class="col-9 d-flex align-items-center">
                <div class="radio-inline">
                  <label class="radio radio-outline radio-success">
                    <input
                      class="engager"
                      type="radio"
                      name="engager"
                      value="1"
                      v-model="vacataire.engager"
                      disabled
                    />
                    <span></span>Ministère de l'Enseignement Supérieur (MES)
                  </label>
                  <label class="radio radio-outline radio-success">
                    <input
                      class="engager"
                      type="radio"
                      name="engager"
                      value="0"
                      v-model="vacataire.engager"
                      disabled
                    />
                    <span></span>Autre
                  </label>
                </div>
              </div>
            </div>
            <!--end::Group-->
            <!--begin::Group-->
            <div class="form-group row">
              <label class="col-form-label col-3 text-lg-right text-left"
                >Établissement</label
              >
              <div class="col-9">
                <div class="input-group input-group-lg input-group-solid">
                  <input
                    type="text"
                    class="form-control form-control-lg form-control-solid"
                    v-model="vacataire.etablissement_dorigine"
                    disabled
                  />
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-form-label col-3 text-lg-right text-left">
                Nombre d'heures
              </label>
              <div class="col-9">
                <div class="input-group input-group-lg input-group-solid">
                  <input
                    type="text"
                    class="form-control form-control-lg form-control-solid"
                    v-model="vacataire.nb_heures"
                    disabled
                  />
                </div>
              </div>
            </div>
            <!--end::Group-->

            <div class="form-group row" v-show="admin.role.nom == 'DE'">
              <label class="col-form-label col-3 text-lg-right text-left">
                VH à ajouter
              </label>
              <div class="col-9">
                <div class="input-group input-group-lg input-group-solid">
                  <input
                    type="number"
                    class="form-control form-control-lg form-control-solid"
                    v-model="nb_heures"
                  />
                </div>
              </div>
            </div>
            <!--begin::Group-->
            <div class="form-group row" v-show="admin.role.nom == 'DE'">
              <label class="col-form-label col-3 text-lg-right text-left">
                Commentaire
              </label>
              <div class="col-9">
                <div class="input-group input-group-lg input-group-solid">
                  <textarea
                    cols="30"
                    rows="5"
                    class="form-control form-control-lg form-control-solid"
                    v-model="commentaire"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="text-center" v-show="admin.role.nom == 'DE'">
              <button
                class="btn btn-success text-center"
                @click="demande_derogation(vacataire)"
                :disabled="this.nb_heures == null"
              >
                Ajouter
              </button>
            </div>
            <div id="historique" style="display: none">
              <h4 class="mt-6">HISTORIQUE</h4>
              <div class="card bg-white">
                <div class="card-body">
                  <div class="timeline timeline-2 historique-time-line">
                    <div class="timeline-bar"></div>
                    <div
                      v-for="derogation in vacataire.derogations"
                      class="timeline-item Accepter"
                      :key="derogation.id"
                    >
                      <div class="timeline-badge">
                        <i class="far fa-circle"></i>
                      </div>
                      <div class="timeline-content align-items-center">
                        <p class="line-1">
                          Le
                          {{
                            derogation.created_at | moment("DD/MM/YYYY H:mm")
                          }}
                        </p>

                        <div class="line-profile d-flex flex-center pb-6">
                          <!--begin::Bullet-->
                          <span
                            class="bullet bullet-bar align-self-stretch mr-4 my-1"
                          >
                          </span>

                          <div class="d-flex flex-column flex-grow-1">
                            <a href="#" class="line-profile-name">
                              {{ derogation.directeur.nom }}
                              {{ derogation.directeur.prenom }} a ajouté
                              {{ derogation.nb_heures }}
                              Heures
                              <span
                                v-show="derogation.status == 'en cours'"
                                class="label label-xl label-info label-inline ml-3"
                              >
                                {{ derogation.status }}
                              </span>
                              <span
                                v-show="derogation.status == 'valide'"
                                class="label label-xl label-success label-inline ml-3"
                              >
                                {{ derogation.status }}
                              </span>
                              <span
                                v-show="derogation.status == 'refusee'"
                                class="label label-xl label-danger label-inline ml-3"
                              >
                                {{ derogation.status }}
                              </span>
                            </a>
                          </div>
                        </div>
                        <div v-show="derogation.commentaire != null">
                          <p>{{ derogation.commentaire }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="delete_derogation_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#DeleteActivity"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <form action="" method="post">
            <div class="modal-header pb-3">
              <h5 class="modal-title" id="modal_enregistrer_header">
                Supprimer dérogation
              </h5>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-secondary btn-circle close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body px-0 py-4 pb-8">
              <div class="d-flex justify-content-center">
                <span class="svg-icon svg-icon-danger svg-icon-10x">
                  <!--begin::Svg Icon | path:C:\wamp64\www\keenthemes\themes\keen\theme\demo1\dist/../src/media/svg/icons\Navigation\Double-check.svg--><svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24" />
                      <circle
                        fill="#000000"
                        opacity="0.3"
                        cx="12"
                        cy="12"
                        r="10"
                      />
                      <rect
                        fill="#000000"
                        x="11"
                        y="7"
                        width="2"
                        height="8"
                        rx="1"
                      />
                      <rect
                        fill="#000000"
                        x="11"
                        y="16"
                        width="2"
                        height="2"
                        rx="1"
                      />
                    </g>
                  </svg>
                </span>
              </div>
            </div>
            <div class="d-flex justify-content-between modal-footer">
              <button
                type="button"
                class="btn bg-D38686 color-FFFFFF px-16 py-3"
                data-dismiss="modal"
                aria-label="Close"
              >
                ANNULER
              </button>
              <button
                @click="delete_derogation()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        opacity="0.3"
                        transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                      />
                      <path
                        d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                      />
                    </g>
                  </svg>
                </span>
                Supprimer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="refuse_derogation_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#DeleteActivity"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <form action="" method="post">
            <div class="modal-header pb-3">
              <h5 class="modal-title" id="modal_enregistrer_header">
                Refusée dérogation
              </h5>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-secondary btn-circle close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body px-0 py-4 pb-8">
              <div class="d-flex justify-content-center">
                <span class="svg-icon svg-icon-danger svg-icon-10x">
                  <!--begin::Svg Icon | path:C:\wamp64\www\keenthemes\themes\keen\theme\demo1\dist/../src/media/svg/icons\Navigation\Double-check.svg--><svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24" />
                      <circle
                        fill="#000000"
                        opacity="0.3"
                        cx="12"
                        cy="12"
                        r="10"
                      />
                      <rect
                        fill="#000000"
                        x="11"
                        y="7"
                        width="2"
                        height="8"
                        rx="1"
                      />
                      <rect
                        fill="#000000"
                        x="11"
                        y="16"
                        width="2"
                        height="2"
                        rx="1"
                      />
                    </g>
                  </svg>
                </span>
              </div>
            </div>
            <div class="d-flex justify-content-between modal-footer">
              <button
                type="button"
                class="btn bg-D38686 color-FFFFFF px-16 py-3"
                data-dismiss="modal"
                aria-label="Close"
              >
                ANNULER
              </button>
              <button
                @click="refuse_derogation()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        opacity="0.3"
                        transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                      />
                      <path
                        d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                      />
                    </g>
                  </svg>
                </span>
                Refuser
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="valide_derogation_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#ValideDerogation"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <form action="" method="post">
            <div class="modal-header pb-3">
              <h5 class="modal-title" id="modal_enregistrer_header">
                Validé dérogation
              </h5>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-secondary btn-circle close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body px-0 py-4 pb-8">
              <div class="d-flex justify-content-center">
                <span class="svg-icon svg-icon-success svg-icon-10x">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "
                      />
                    </g>
                  </svg>
                </span>
              </div>
            </div>
            <div class="d-flex justify-content-between modal-footer">
              <button
                type="button"
                class="btn bg-D38686 color-FFFFFF px-16 py-3"
                data-dismiss="modal"
                aria-label="Close"
              >
                ANNULER
              </button>
              <button
                @click="valide_derogation()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <span class="svg-icon svg-icon-success svg-icon-2x">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <polygon points="0 0 24 0 24 24 0 24" />
                        <path
                          d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "
                        />
                      </g>
                    </svg>
                  </span>
                </span>
                Valider
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VclTable } from "vue-content-loading";
export default {
  props: {
    admin: {},
  },
  components: {
    VclTable,
  },
  data() {
    return {
      allVacataires: [],
      allDerogations: [],
      vacataires: [],
      derogations: [],
      derogation: {},
      vacataire: [],
      vacatairesLoaded: null,
      derogationsLoaded: null,
      keyword: null,
      nb_heures_old: null,
      nb_heures: null,
      commentaire: "",
      config: {
        headers: {
          Authorization: "Bearer " + this.admin.api_token,
        },
      },
    };
  },
  watch: {
    keyword(after, before) {
      if (this.keyword != "") {
        this.getResults();
      } else {
        this.reloadVacataires();
      }
    },
  },
  methods: {
    show(vacataire) {
      this.vacataire = vacataire;
      this.nb_heures_old = vacataire.nb_heures;
      var historique = document.getElementById("historique");

      if (vacataire.derogations.length == 0) {
        historique.style.display = "none";
      } else {
        historique.style.display = "block";
      }
    },
    demande_derogation(vacataire) {
      if (this.nb_heures > 0) {
        axios
          .post(
            "/api/vacataires/derogation/" + vacataire.id + "/" + this.admin.id,
            {
              nb_heures: this.nb_heures,
              commentaire: this.commentaire,
            },
            this.config
          )
          .then((res) => {
            this.vacataire = res.data;
            this.nb_heures_old = vacataire.nb_heures;
            this.nb_heures = null;
            this.commentaire = "";
            this.reloadDerogations();
            var historique = document.getElementById("historique");
            historique.style.display = "block";
            Vue.swal.fire({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              title: "Nombre d'heure modifié!",
              icon: "success",
              confirmButtonText: "Cool",
            });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        Vue.swal.fire({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          title: "Le nombre d'heures doit être supérieur de 0!",
          icon: "error",
          confirmButtonText: "Cool",
        });
      }
    },
    getResults() {
      axios
        .get("/api/search/vacataires/" + this.keyword, this.config)
        .then((res) => (this.vacataires = res.data))
        .catch((error) => {});
    },
    onChangePage(vacataires) {
      // update page of items
      this.vacataires = vacataires;
    },
    onChangePageDerogation(derogations) {
      // update page of items
      this.derogations = derogations;
    },
    reloadVacataires() {
      axios.get("/api/get/vacataires", this.config).then((res) => {
        this.allVacataires = res.data;
        this.vacatairesLoaded = 1;
      });
    },

    reloadDerogations() {
      axios
        .get("/api/get/derogations/" + this.admin.id, this.config)
        .then((res) => {
          this.allDerogations = res.data;
          this.derogationsLoaded = 1;
        });
    },

    delete_derogation_modal(derogation) {
      this.derogation = derogation;
      $("#delete_derogation_modal").modal("show");
    },

    delete_derogation() {
      axios
        .delete("/api/derogation/delete/" + this.derogation.id, {}, this.config)
        .then((response) => {
          $("#delete_derogation_modal").modal("hide");
          this.derogation = {};
          this.reloadDerogations();
          this.reloadVacataires();
          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Derogation supprimé!",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    valide_derogation_modal(derogation) {
      this.derogation = derogation;
      $("#valide_derogation_modal").modal("show");
    },

    valide_derogation() {
      axios
        .put(
          "/api/derogation/valide/" + this.derogation.id + "/" + this.admin.id,
          {},
          this.config
        )
        .then((response) => {
          $("#valide_derogation_modal").modal("hide");
          this.derogation = {};
          this.reloadDerogations();
          this.reloadVacataires();
          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Derogation validé",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    refuse_derogation_modal(derogation) {
      this.derogation = derogation;
      $("#refuse_derogation_modal").modal("show");
    },

    refuse_derogation() {
      axios
        .put(
          "/api/derogation/refuse/" + this.derogation.id + "/" + this.admin.id,
          {},
          this.config
        )
        .then((response) => {
          $("#refuse_derogation_modal").modal("hide");
          this.derogation = {};
          this.reloadDerogations();
          this.reloadVacataires();
          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Derogation refusée",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  beforeMount() {
    axios.get("/api/get/vacataires", this.config).then((res) => {
      this.allVacataires = res.data;
      this.vacatairesLoaded = 1;
    });

    axios
      .get("/api/get/derogations/" + this.admin.id, this.config)
      .then((res) => {
        this.allDerogations = res.data;
        this.derogationsLoaded = 1;
      });
  },
};
</script>
